import { useNavigate } from "react-router-dom";
import styled from "styled-components";

function InstructorItem({id, profileImg, name, history, description}){
    const navigate = useNavigate();
    return(
        <Container>
           <ProfileImg src={profileImg} alt="profile_image"/>
           <Content>
                <Name>{name}</Name>
                <History>{history}</History>
                <Description>{description}</Description>
           </Content>
           <Button onClick={() => navigate(`/product/${id}`)}>강의 구매 하기</Button>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex-basis: 100%;
    gap: 40px;
    width: 400px;
    @media (max-width: 768px) {
        width: 100%;
    }
`

const ProfileImg = styled.img`
    width: 100%;
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex-grow: 1;
`

const Name = styled.div`
    font-size: 22px;
    color: #111;
`

const History = styled.div`
    font-size: 18px;
    color: #777;
    white-space: pre-wrap;
`

const Description = styled.div`
    font-size: 18px;
    color: #777;
`

const Button = styled.button`
    background: #007912;
    border-radius: 12px;
    border: none;
    padding:12px;
    width: 100%;
    color: #FFF;
    font-size: 20px;
    font-weight: 700;
    cursor: pointer;
`

export default InstructorItem;